/* __next_internal_client_entry_do_not_use__ DrawerEventDescription auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Drawer, DrawerContent, DrawerTitle } from "@/ui/drawer";
import styles from "./index.module.scss";
import stylesBtn from "../../../btn.module.scss";
import Image from "next/image";
import DescriptionIcon from "../../../assets/descriptionIcon.webp";
import classNames from "classnames";
import { BottomBox } from "../../BottomBox";
import { Close } from "../../Close";
const DrawerEventDescription = (param)=>{
    let { open, onClose } = param;
    const t = useTranslations();
    const title = useMemo(()=>t("bgbStakingActivityDescription"), [
        t
    ]);
    const stepList = useMemo(()=>{
        return [
            {
                // title: t('staking', { coin: 'BGB' }),
                description: t("bgbStakingEventDescription1")
            },
            {
                // title: t('earnIncomeEveryDay'),
                description: t("bgbStakingEventDescription2")
            },
            {
                // title: t('earnIncomeEveryDay'),
                description: t("bgbStakingEventDescription3")
            }
        ];
    }, [
        t
    ]);
    return /*#__PURE__*/ _jsx(Drawer, {
        open: open,
        onClose: onClose,
        title: title,
        children: /*#__PURE__*/ _jsxs(DrawerContent, {
            className: "bg-[var(--bg-0)] relative pt-[18px] px4 gap-0 rounded-t-[12px] h-[calc(100vh-110px)]",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-col h-full",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex-shrink-0 pb-28px flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ _jsx(DrawerTitle, {
                                    className: "text-[20px] leading-28px font-700 text-[var(--text-1)]",
                                    children: title
                                }),
                                /*#__PURE__*/ _jsx(Close, {
                                    onClick: onClose
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "overflow-y-auto grow-1",
                            children: /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "bg-#15151A relative rounded-4 border border-solid border-#25262E mb-24px px4",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: classNames(styles.lamp, styles.leftLamp)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: classNames(styles.lamp, styles.rightLamp)
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex flex-col items-center relative",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Image, {
                                                        src: DescriptionIcon.src,
                                                        width: 114,
                                                        height: 113,
                                                        alt: "bg icon",
                                                        className: "mt-15px mb-23px"
                                                    }),
                                                    /*#__PURE__*/ _jsx("h3", {
                                                        className: "font-900 text-29px leading-46px mb4 text-center ".concat(styles.rainbowText),
                                                        children: t("bgbStakingIllustrateTitle")
                                                    }),
                                                    /*#__PURE__*/ _jsx("p", {
                                                        className: "text-center text-#888A98 text-15px leading-25px mb-33px",
                                                        children: t("bgbStakingDescription")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: styles.title,
                                                children: t("whatIsBgb")
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text-15px leading-25px text-[var(--text-1)]",
                                                children: t("bitgetTokenDescription")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mt6 mb-120px",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: styles.title,
                                                children: t("threeStepsToEarnYield")
                                            }),
                                            /*#__PURE__*/ _jsx("ol", {
                                                className: "flex flex-col gap-22px text-15px",
                                                children: stepList.map((item, index)=>{
                                                    return /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx("p", {
                                                            className: "text-[var(--text-7)] leading-25px",
                                                            children: item.description
                                                        })
                                                    }, index);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(BottomBox, {
                    className: "absolute bottom-0 left-0",
                    children: /*#__PURE__*/ _jsx("button", {
                        onClick: onClose,
                        className: "".concat(stylesBtn.bigBtn, " ").concat(stylesBtn.wBtn),
                        children: t("knew")
                    })
                })
            ]
        })
    });
};
export { DrawerEventDescription };
